import React from 'react';
import type { AuthBrandConfig } from './types';

/**
 * Default spinner used in auth pages when no custom spinner is provided.
 * Simple circular border spinner that uses the brand's button color.
 */
export const AuthSpinner: React.FC<{ brand: AuthBrandConfig; size?: 'sm' | 'md' }> = ({ brand, size = 'md' }) => {
  const sizeClass = size === 'sm' ? 'w-4 h-4' : 'w-8 h-8';
  return (
    <div
      className={`${sizeClass} animate-spin rounded-full border-2 border-transparent`}
      style={{ borderTopColor: brand.buttonTextColor, borderRightColor: brand.buttonTextColor }}
    />
  );
};
